/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import AllReports from "./AllReports";
import { LayoutContext } from "../../components/layout";
import UserModal from "../../components/Modals/UserModal";

const UsersList = () => {
  const { user } = useContext(LayoutContext);
  const [selectedTab, setSelectedTab] = useState("patients");
  const history = useHistory();
  const { tab } = useParams();
  const [userObject, setUserObject] = useState({});

  useEffect(() => {
    if (typeof tab === "undefined") setSelectedTab("users");
    else setSelectedTab(tab);
  }, [tab]);

  const classNameTab = (pos) => {
    if (pos === selectedTab) return "tabActive";
    else return "";
  };

  return (
    <div id="index" className="containerFlex maxHd">
      <div className="contentArea">
        <div className="up-interrog" style={{ display: "flex", justifyContent: "flex-end" }}>
          <a href="#addUser">
            <button
              className="btn btnSuccess"
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              disabled={user && user.groups.findIndex((g) => g.name === "admin_group") === -1}
            >
              <div className="upload-icon icon-64" style={{ marginRight: "10px" }}></div> Add User
            </button>
          </a>
        </div>

        <nav className="tabs" id="report-navigation">
          <a
            href="#"
            className={classNameTab("users")}
            style={{ marginRight: "80%" }}
            onClick={(e) => {
              e.preventDefault();
              setSelectedTab("users");
              history.push("/users3");
            }}
          >
            <span className="tab-text">Users</span>
          </a>
        </nav>

        <div className="tabContent">
          <AllReports activeTab={selectedTab} />
        </div>

        <UserModal
          title={"Add User"}
          editMode={false}
          userObject={userObject}
          setUserObject={setUserObject}
          modalId="addUser"
        />
      </div>
    </div>
  );
};

export default UsersList;
